import { forwardRef, type Ref, type SVGProps } from "react";
function SvgGiftOutlined(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        stroke="currentColor"
        strokeLinejoin="round"
        d="M12 8.143V6.429m0 1.714h-1.818c-2.008 0-3.637-1.535-3.637-3.429C6.545 3.768 7.36 3 8.364 3 10.372 3 12 4.535 12 6.429m0 1.714h1.818c2.008 0 3.637-1.535 3.637-3.429 0-.946-.814-1.714-1.819-1.714C13.628 3 12 4.535 12 6.429m0 1.714H5.182C3.977 8.143 3 9.063 3 10.2v.257c0 .762.439 1.426 1.09 1.782M12 8.143h6.818c1.205 0 2.182.92 2.182 2.057v.257c0 .762-.439 1.426-1.09 1.782M12 8.143v4.371M12 21H6.273c-1.205 0-2.182-.921-2.182-2.057v-6.704M12 21h5.727c1.205 0 2.182-.921 2.182-2.057v-6.704M12 21v-8.486m0 0h6.818c.398 0 .77-.1 1.091-.275M12 12.514H5.182c-.398 0-.77-.1-1.091-.275m0-.239v.24m15.818 0V12"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgGiftOutlined);
export default ForwardRef;
